<div class="wrapper">
  <div class="header">
    <div>
      <img src="./assets/finspot-logo.png" alt="Finspot Logo" width="242" height="214">
    </div>
    <div class="header-title">
      <span>Heartbeat</span>
    </div>
    <div>
      <img src="./assets/ekg.png" alt="EKG drawing" width="242" height="214">
    </div>
  </div>

  <div id="row0" class="row ml-20">
    <div class="row-item">
      <label for="apiKey" class="label-style">API Key</label>
      <input id="apiKey"  #apiKey type="text" class="input-style">
    </div>
    <div class="row-item">
      <label for="analysisId" class="label-style">Analysis Id</label>
      <input id="analysisId" #analysisId type="text" class="input-style">
    </div>
  </div>

  <div class="divider"></div>

  <div class="row">
    <btw-button
      text="Upload"
      (onClick)="handleUpload()" />
  </div>

  <div id="row1" class="row">
    <div class="graph">
      <div id="salariesChart"></div>
    </div>
    
    <div class="desc">
      <div class="desc-title">
        <p>Salaries</p>
        <!-- <div class="button-primary"> -->
          <button (click)="populateSumGraph('Salary', 'salariesChart', false)" class="button-primary">Show</button>
        <!-- </div> -->
      </div>
      <span>This indicator shows activities related to salary payments. It can indicate an issue with the company
        liquidity in case the salary payments are not paid out in regular intervals and\or there is a change in the
        pattern or size of payouts.</span>
    </div>

    
  </div>

  <div class="row">
    <div class="graph">
      <div id="salariesChartCount"></div>
    </div>
    <div>
    </div>
  </div>

  <div class="row">
    <div class="graph">
      <div id="salariesChartIndicator0"></div>
    </div>
    <div class="graph">
      <div id="salariesChartIndicator1"></div>
    </div>
    <div class="graph">
      <div id="salariesChartIndicator2"></div>
    </div>
    <div class="graph">
      <div id="salariesChartIndicator3"></div>
    </div>
  </div>

  <div class="divider"></div>
  <div id="hook2" class="divider"></div>

  <div id="row2" class="row">
    <div class="graph">
      <div id="ioChart"></div>
    </div>
    <div class="desc notice">
      <div class="desc-title">
        <p>Income and Outcome</p>
        <button (click)="populateSumGraph('IncomeOutcome', 'ioChart', false)" class="button-primary">Show</button>
      </div>
      <span>This indicator shows activities related to income and outcome payments. It can indicate issues with company
        ability to collect payments or changes in the dynamics of inflows and outflows that can hint at an underlying
        problem with liquidity.</span>
    </div>
  </div>

  <div class="row">
    <div class="graph">
      <div id="ioChartCount"></div>
    </div>
  </div>

  <div class="row">
    <div class="graph">
      <div id="ioChartIndicator0"></div>
    </div>
    <div class="graph">
      <div id="ioChartIndicator1"></div>
    </div>
    <div class="graph">
      <div id="ioChartIndicator2"></div>
    </div>
    <div class="graph">
      <div id="ioChartIndicator3"></div>
    </div>
  </div>

  <div class="divider"></div>
  <div id="hook3" class="divider"></div>

  <div id="row3" class="row">
    <div class="graph">
      <div id="taxChart"></div>
    </div>
    <div class="desc notice">
      <div class="desc-title">
        <p>Taxes And Contributions</p>
        <button (click)="populateSumGraph('TaxesAndContributions', 'taxChart', false)" class="button-primary">Show</button>
      </div>
      <span>Taxes and contributions can be paid up to 30 days after the salaries. Increase in duration between salary
        and taxes payment could indicate that the company is struggling to pay its obligations.</span>
    </div>
  </div>

  <div class="row">
    <div class="graph">
      <div id="taxChartCount"></div>
    </div>
  </div>

  <div class="row">
    <div class="graph">
      <div id="taxChartIndicator0"></div>
    </div>
    <!-- TODO: Uncomment once indicators are calculated meanigfully -->
    <!-- <div class="graph">
      <div id="taxChartIndicator1"></div>
  </div>
  <div class="graph">
      <div id="taxChartIndicator2"></div>
  </div> -->
    <div class="graph">
      <div id="taxChartIndicator3"></div>
    </div>
    <!-- <div class="graph">
      <div id="taxChartIndicator4"></div>
  </div>
  <div class="graph">
      <div id="taxChartIndicator5"></div>
  </div> -->
  </div>

  <div class="divider"></div>
  <div id="hook4" class="divider"></div>

  <div id="row4" class="row">
    <div class="graph">
      <div id="iTrasnferChart"></div>
    </div>
    <div class="desc notice">
      <div class="desc-title">
        <p>Internal Transfers</p>
        <button (click)="populateSumGraph('InternalTransfer', 'iTrasnferChart', false)" class="button-primary">Show</button>
      </div>
      <span>This indicator shows internal trasnfers. Increased activity or changes of pattern could indicate that the
        company struggles to collect funds for paying certain obligations.</span>
    </div>
  </div>

  <div class="row">
    <div class="graph">
      <div id="iTrasnferChartCount"></div>
    </div>
  </div>

  <div class="row">
    <div class="graph">
      <div id="iTrasnferChartIndicator0"></div>
    </div>
    <div class="graph">
      <div id="iTrasnferChartIndicator1"></div>
    </div>
  </div>

  <div class="divider"></div>
  <div id="hook5" class="divider"></div>

  <div id="row5" class="row">
    <div class="graph">
      <div id="loanChart"></div>
    </div>
    <div class="desc notice">
      <div class="desc-title">
        <p>Loans</p>
        <button (click)="populateSumGraph('Loans', 'loanChart', true)" class="button-primary">Show</button>
      </div>
      <span>This indicator shows loan payments performed by the company. It can indicate an underyling issue by showing
        that the company is struggling to pay it's monthly obligations in a consistent manner. It can also indicate
        amount of debt taken by the company.</span>
    </div>
  </div>

  <div class="row">
    <div class="graph">
      <div id="loanChartCount"></div>
    </div>
  </div>

  <!-- <div class="row">
    <div class="graph">
        <div id="loanChartIndicator0"></div>
    </div>
    <div class="graph">
        <div id="loanChartIndicator1"></div>
    </div>
  </div> -->

  <div class="divider"></div>
  <div id="hook6" class="divider"></div>

  <div id="row6" class="row">
    <div class="graph">
      <div id="roundPaymentChart"></div>
    </div>
    <div class="desc notice">
      <div class="desc-title">
        <p>Round payments</p>
        <button (click)="populateSumGraph('RoundPayments', 'roundPaymentChart', true)" class="button-primary">Show</button>
      </div>
      <span>This indicator shows inflows and outflows that are round on last 6 decimasl. With the increase of round
        outflows the company could have an issue with being able to pay it's obligations.</span>
    </div>
  </div>

  <div class="row">
    <div class="graph">
      <div id="roundPaymentChartCount"></div>
    </div>
  </div>

  <div class="row">
    <div class="graph">
      <div id="roundPaymentChartIndicator0"></div>
    </div>
    <div class="graph">
      <div id="roundPaymentChartIndicator1"></div>
    </div>
  </div>

  <div class="divider"></div>
  <div id="hook7" class="divider"></div>

  <div id="row7" class="row">
    <div class="graph">
      <div id="tableView"></div>
    </div>
    <div class="desc notice">
      <div class="desc-title">
        <p>Financial statements</p>
        <button (click)="populateFinStatementsChart()" class="button-primary">Show</button>
      </div>
      <span>This indicator shows evolution of balance sheet positions in real-time.</span>
    </div>
  </div>
  <div class="row table-stats" id="finStatementsTable"></div>

</div>